import React, { Component, Fragment } from 'react';
import { __, __n } from 'i18n-for-browser';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { cookie } from 'glxl-helpers';

import apiCall from '../apiCall';
import RankingRow from '../elements/RankingRow';
import ContentContainer from '../elements/ContentContainer';
import Loading from '../elements/Loading';
import ListButton from '../elements/ListButton';
import { icons } from '../../assets/assets';
import PopupTitle from "../elements/PopupTitle";
import { getPopupDeviceDifficulty, dispatchUnreadPopup } from "../../helpers/popupHelper";
import { getGroupAvatarUrl } from '../../helpers/groupHelper';
import Defines from "../../Defines";
import config from '../../config'

class ClassLeaderPortalHome extends Component {
  static propTypes = {
    history: PropTypes.shape({
      push: PropTypes.func,
    }).isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      downloading: [],
      schoolClassFilter: true,
      schoolClasses: [],
    };
    this.gameId = parseInt(this.props.match.params.gameId, 10);
    this.deviceAndDifficulty = getPopupDeviceDifficulty(this.props.gameState.DefaultDifficultyId);
  }

  componentWillMount() {
    apiCall(`/schoolClass/simGameSchoolClasses/${this.props.project.id}`)
      .then((schoolClasses) => {
        this.setState({ schoolClasses });
      });
  }

  updateSchoolClassFilter = (f) => {
    this.setState({ schoolClassFilter: f });
  };

  componentDidMount() {
    const { dispatch, project, gameState } = this.props;
    const currentRound = (gameState.Rounds ? gameState.Rounds.length - 1 : 1);
    if (currentRound <= 1 && project.EducationProjectId === 2) {
      dispatchUnreadPopup((project.difficulty === "PRO" ? 'mhbvtintro_inleiding_T1' : 'mlbvtintro_inleiding_T1'), dispatch);
    }
  }

  renderTitle = () => {
    return this.state.schoolClassFilter
      ? (
        <PopupTitle popupId={`${this.deviceAndDifficulty}bvtteams`} tag={'h3'} />
      )
      : (
        <h3>
          {__('sim_tussenstand')}
        </h3>
      )
  };

  renderGroupRows() {
    const { schoolClasses } = this.state;
    const { schoolClass } = this.props;
    if (!schoolClasses.length) return <Loading />;
    const groups = schoolClasses.reduce((acc, sc) => {
      return acc.concat(sc.Groups.map(g => ({ ...g, SchoolClass: sc })));
    }, [])
      .filter(g => !this.state.schoolClassFilter || g.SchoolClassId === schoolClass.id)
      .sort((a, b) => b.totalPoints - a.totalPoints);
    return groups.map((grp, i) => {
      const to = grp.SchoolClassId === schoolClass.id;
      return (
        <RankingRow
          key={grp.id}
          rank={i + 1}
          title={grp.name}
          color={grp.GroupTheme.color}
          showSchoolClassName={!this.state.schoolClassFilter}
          className={grp.SchoolClass.className}
          points={grp.totalPoints || 0}
          avatar={getGroupAvatarUrl(grp, this.props.project, '')}
          to={to
            ? `/portal/classleader/teaminfo/${grp.id}`
            : ''
          }
        />
      );
    })
  }

  renderGameButtons = () => {
    const { schoolClass } = this.props;
    if (!Array.isArray(schoolClass.SchoolClassGames)) return null;
    const games = schoolClass.SchoolClassGames.reduce((arr, val) => {
      if (val.Game.abbreviation !== 'SS' && val.Game.abbreviation !== 'BO') arr.push(val.Game);
      return arr;
    }, []);

    return (
      <div className={'button-section'}>
        <div className={'title-container'}>
          {this.props.project.EducationProject.nameShort === 'GLXL' ? (
            <PopupTitle popupId={`${this.deviceAndDifficulty}bvtverdienen`} tag={'h3'} />
          ) : (
            <span>
              <h3>
                {__n('sim_spel', 0)}
              </h3>
            </span>
          )}
        </div>
        {games.map((g) => {
          const curGame = Defines.gameLogos.find(game => game.id === g.id);
          return (
            <ListButton
              key={g.id}
              title={__(g.name)}
              icon={curGame.logo}
              className={'opacity gameButton'}
              onClick={() => {
                this.props.history.push(`/portal/classleader/verdienen/${g.id}`);
              }}
            />
          );
        })}
      </div>
    );
  };

  renderPrepareButton = () => {
    return (
      <Fragment>
        <div className={'button-section'}>
          <div className={'title-container'}>
            <PopupTitle popupId={`${this.deviceAndDifficulty}bvtvoorbereiding`} tag={'h3'} />
          </div>
          <ListButton
            title={__('sim_voorbereiding_begeleider')}
            icon={icons.checklist}
            className={'opacity'}
            onClick={() => {
              this.props.history.push('/portal/classleader/prepare');
            }}
          />
        </div>

        <div className={'button-section'}>
          <div className={'title-container'}>
            <PopupTitle popupId={`${this.deviceAndDifficulty}bvtopstart`} tag={'h3'} />
          </div>
          <ListButton
            title={__('sim_opstart_project')}
            icon={icons.startup}
            className={'opacity'}
            onClick={() => {
              this.props.history.push('/portal/classleader/prepare/startup');
            }}
          />
        </div>
      </Fragment>
    );
  };

  renderGlobasVerdelenButton = () => {
    const curGame = Defines.gameLogos.find(game => game.id === 1);
    console.log(curGame);
    if (curGame === undefined) {
      return null;
    }
    return (
      <div className={'button-section'}>
        <div className={'title-container'}>
          <PopupTitle popupId={`${this.deviceAndDifficulty}bvtverdelen`} tag={'h3'} />
        </div>
        <ListButton
          title={__('sim_land_besturen')}
          icon={curGame.logo}
          className={'opacity gameButton'}
          onClick={() => {
            this.props.history.push('/portal/classleader/verdelen');
          }}
        />
      </div>
    );
  };

  renderBonusSection = () => {
    const { schoolClass } = this.props;
    if (Array.isArray(schoolClass.SchoolClassGames)) {
      if (schoolClass.SchoolClassGames.findIndex(g => g.Game.abbreviation === 'BO') === -1) {
        return null;
      }
    }
    const curGame = Defines.gameLogos.find(game => game.abbreviation.toLowerCase() === 'bo');
    return (
      <div className={'button-section'}>
        <div className={'title-container'}>
          <PopupTitle popupId={`${this.deviceAndDifficulty}bvtbonuspunten`} tag={'h3'} />
        </div>
        <ListButton
          title={__('sim_extra_opdrachten')}
          icon={curGame.logo}
          className={'opacity'}
          onClick={() => {
            this.props.history.push('/portal/classleader/bonuspoints');
          }}
        />
      </div>
    );
  };

  renderFairawayButton = () => {
    return (
      <div className={'button-section'}>
        <div className={'title-container'}>
          <PopupTitle popupId={`${this.deviceAndDifficulty}bvtreizen`} tag={'h3'} />
        </div>
        <ListButton
          title={__('sim_fairaway')}
          icon={icons.fairaway}
          className={'opacity'}
          onClick={() => {
            this.props.history.push('/portal/classleader/prepare/fairaway');
          }}
        />
      </div>
    );
  };

  renderOverigeButtons = () => {
    return (
      <div className={'button-section'}>
        <div className={'title-container'}>
          <PopupTitle popupId={`${this.deviceAndDifficulty}bvtfotosfilmpjes`} tag={'h3'} />
        </div>
        <ListButton
          title={__n('sim_fotos_uploaden', 0)}
          icon={icons.camera}
          className={'opacity'}
          onClick={() => {
            this.props.history.push('/portal/classleader/media');
          }}
        />
        {this.props.project.festiveEndingInClass ? (
          <button
            className={'festive-ending-btn'}
            onClick={() => {
              const token = (sessionStorage.getItem('token') || cookie.getCookie('token') || '').replace(/^Bearer\s+/i, '');
              const url = `${config.adminUrl}/FestiveEnding/${this.props.project.id}?standalone=1${token ? `&token=${encodeURIComponent(token)}` : ''}`;
              window.open(url, 'React', 'resizable=yes, scrollbars=yes, width=1451, height=920, left=300, top=200');
            }}
          >
            <span>{__('sim_prijsuitreiking')}</span>
          </button>
        ) : null}
      </div>
    );
  };

  renderPDFButtons = () => {
    return (
      <div className={'pdf-button-container'}>
        <button
          className={(this.state.downloading.includes('groupStudentLogins') ? 'disabled' : '')}
          onClick={() => { this.downloadPdf('groupStudentLogins'); }}
        >
          <span>{__('sim_pdf_logins_groepen')}</span>
        </button>
        <button
          className={(this.state.downloading.includes('groupLayout') ? 'disabled' : '')}
          onClick={() => { this.downloadPdf('groupLayout'); }}
        >
          <span>{__('sim_pdf_groepsindeling')}</span>
        </button>
      </div>
    );
  };

  renderTeams = () => {
    const { schoolClassFilter } = this.state;
    return (
      <div className={'button-section'}>
        <div className={'title-container'}>
          <div>
            {this.renderTitle()}
          </div>
          <div>
            <button
              className={schoolClassFilter ? '' : 'inactive'}
              onClick={() => { this.updateSchoolClassFilter(true) }}
            >
              <span>{__n('sim_klas', 1)}</span>
            </button>
            <button
              className={schoolClassFilter ? 'inactive' : ''}
              onClick={() => { this.updateSchoolClassFilter(false) }}
            >
              <span>{__n('sim_school', 1)}</span>
            </button>
          </div>
        </div>
        <div className={'ranking-rows-container'}>
          {this.renderGroupRows()}
        </div>
      </div>
    )
  };

  downloadPdf = async (pdfType) => {
    if (this.state.downloading.includes(pdfType)) return false;
    const token = cookie.getCookie('token');
    window.open(`${config.apiUrl}/pdf/${pdfType}/${this.props.schoolClass.id}?authorization=${token}`, '_blank');
  };

  render() {
    if (!this.props.project.loaded || !this.props.gameState.loaded) {
      return null;
    }
    const { desktop } = this.props;
    const projectType = this.props.project.EducationProject.nameShort;
    const hideScores = this.props.gameState.hideScores;
    if (desktop) {
      return (
        <div className={'portal-home classleader-portal classleader-portal-home'}>
          <div className={`container ${projectType !== 'GLXL' ? 'overige-projecten' : ''}`} style={{ maxWidth: '1252px' }}>
            {projectType === 'GLXL' ? (
              <Fragment>
                <div className="column-portal">
                  {this.renderGlobasVerdelenButton()}
                  {this.renderGameButtons()}
                </div>
                <div className={'column-portal'}>
                  {this.renderPrepareButton()}

                  <Fragment>
                    {this.renderFairawayButton()}
                    {this.renderBonusSection()}
                    {this.renderPDFButtons()}
                  </Fragment>
                </div>
              </Fragment>
            ) : <div className="column-portal">{this.renderGameButtons()}</div>}

            {projectType === 'GLXL'
              ? hideScores ?
                (
                  <div className="column-portal">
                    <ContentContainer className="button-section disabled-scores-container" style={{ marginTop: '40px', marginBottom: '5px' }}><p className={'disabled-scores'}>{__('sim_tussenstand_uitgeschakeld')}</p></ContentContainer>
                    {this.renderOverigeButtons()}
                  </div>
                ) : (
                  <div className={"column-portal"}>
                    {this.renderTeams()}
                    {this.renderOverigeButtons()}
                  </div>
                )
              : null}

          </div>
        </div>
      )
    } else {
      return (
        <div className={'classleader-portal-home'}>
          <div className={'container'}>
            <div>
              {projectType === 'GLXL' && !hideScores
                ? (this.renderTeams())
                : null}
              {this.state.schoolClassFilter ? (
                <Fragment>
                  {projectType === 'GLXL'
                    ? (
                      <div>
                        {hideScores ? <ContentContainer className="button-section disabled-scores-container"><p className={'disabled-scores'}>{__('sim_tussenstand_uitgeschakeld')}</p></ContentContainer> : null}
                        {this.renderPrepareButton()}
                      </div>
                    )
                    : null}

                  {projectType === 'GLXL'
                    ? <div>
                      {this.renderGlobasVerdelenButton()}
                      {this.renderGameButtons()}
                      {this.renderBonusSection()}
                      {this.renderFairawayButton()}
                      {this.renderOverigeButtons()}
                      {this.renderPDFButtons()}
                    </div>
                    : this.renderGameButtons()
                  }
                </Fragment>
              ) : null}
            </div>
          </div>
        </div>
      );
    }
  }
}

export default connect(state => ({
  project: state.project,
  schoolClass: state.schoolClass,
  gameState: state.gameState,
}))(ClassLeaderPortalHome);



// WEBPACK FOOTER //
// ./src/components/routes/ClassLeaderPortalHome.js